import React, { ComponentProps, VoidFunctionComponent } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './InputLayout.module.css';

export type InputLayoutProps = Omit<ComponentProps<'label'>, 'children'> & {
  label: string;
  children: (options: InputLayoutRenderOptions) => JSX.Element;
  /**
   * Only a min height for the content will be set instead of a fixed height.
   * This allows the content to be bigger than 40 px and spread over multiple lines
   */
  multiline?: boolean;
};

export const InputLayout: VoidFunctionComponent<InputLayoutProps> = React.memo(
  (props) => {
    const { label, children, className, multiline, ...remainingProps } =
      prepareProps({ props });

    return (
      <label
        {...remainingProps}
        className={classes(className, styles.label)}
      >
        {label ? <div className={styles.labelText}>{label}</div> : undefined}
        <div
          className={classes(
            styles.inputWrapper,
            multiline ? styles.inputWrapperMultiline : null
          )}
        >
          {children({})}
        </div>
      </label>
    );
  }
);

export type InputLayoutRenderOptions = Record<never, never>;
